import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import {type ApplicationContextInterface} from "@@/package/application/applicationContext";
import LevelAssessmentApi from "~~/package/apis/levelAssessment/LevelAssessmentApi";
import {LevelAssessmentModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentModel";
import {LevelAssessmentHelper} from "~~/package/mapper/levelAssessment/LevelAssessmentHelper";
import {TaskModel} from "~~/package/mapper/learning/model/TaskModel";
import type LevelAssessmentTaskResponse from "~~/package/apis/levelAssessment/response/LevelAssessmentTaskResponse";
import type LevelAssessmentSubmitRequest from "~~/package/apis/levelAssessment/request/LevelAssessmentSubmitRequest";
import {LevelAssessmentResultListModel} from "~~/package/mapper/levelAssessment/model/LevelAssessmentResultListModel";
import type LevelAssessmentIdListResponse from "~~/package/apis/levelAssessment/response/LevelAssessmentIdListResponse";
import type CustomResponse from "~~/package/types/ResponseType";

export default class LevelAssessmentMapper {

    protected levelAssessmentApi: LevelAssessmentApi;
    constructor(context: ApplicationContextInterface) {
        this.levelAssessmentApi =  context.getService<LevelAssessmentApi>(DependencyInjectId.LevelAssessmentApi)
    }

    public async getLevelAssessmentBasicInfo(levelId :number): Promise<LevelAssessmentModel> {
        const response: CustomResponse<LevelAssessmentModel> = (await this.levelAssessmentApi.getLevelAssessmentBasicInfo(levelId)).data;
        return LevelAssessmentHelper.mappingLevelAssessmentInfo(response.data);
    }

    public async getLevelAssessmentInfo(levelId :number): Promise<LevelAssessmentModel> {
        const response: CustomResponse<LevelAssessmentModel> = (await this.levelAssessmentApi.getLevelAssessmentInfo(levelId)).data;
        return LevelAssessmentHelper.mappingLevelAssessmentInfo(response.data);
    }

    public async getLevelAssessmentIdList(levelId :number, status: string): Promise<LevelAssessmentIdListResponse> {
        return (await this.levelAssessmentApi.getLevelAssessmentIdList(levelId, status)).data.data;
    }

    public async getLevelAssessmentTask(taskTemplateId: number, levelId: number): Promise<TaskModel> {
        const response: CustomResponse<LevelAssessmentTaskResponse> = (await this.levelAssessmentApi.getLevelAssessmentTask(taskTemplateId, levelId)).data;
        return LevelAssessmentHelper.mappingLevelAssessmentData(response.data);
    }

    public async submitAnswer(levelId: number, taskTemplateId: number, submitData: LevelAssessmentSubmitRequest): Promise<boolean> {
        return (await this.levelAssessmentApi.submitAnswer(levelId, taskTemplateId, submitData)).data.data;
    }

    public async getLevelAssessmentResultList(levelId :number): Promise<LevelAssessmentResultListModel[]> {
        const response: CustomResponse<LevelAssessmentResultListModel[]> = (await this.levelAssessmentApi.getLevelAssessmentResultList(levelId)).data;
        return response.data.map((levelAssessmentResult) => LevelAssessmentHelper.mappingLevelAssessmentResult(levelAssessmentResult));
    }
}
